// #region Imports
import { defineComponent, defineAsyncComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-file-field2',
    mixins: [appHost.mixins.form],
    components: {
        DxFileUploader: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxCommon" */ /* webpackMode: "lazy" */ 'devextreme-vue/file-uploader')).DxFileUploader;
        }),
    },
    // #endregion
    // #region Props
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
    },
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
    // #endregion
});
// #endregion
